import React, { useState, useEffect } from 'react';
import { GetAuth } from '../../Auth/AuthProvider';
// import { NoHeaderTableUpdate } from '../../Helpers/requests';
import { r2_noHeaderTableUpdate } from '../../Helpers/r2_requests';

import ExportToCsv from '../../Helpers/CsvExport';
import UnauthorisedAccess from '../CommonComponents/UnauthorisedAccess';

import { changeFirstToUpper, convertDate } from '../../Helpers/helpers';

import { DataGrid } from '@mui/x-data-grid';
import {
  Box,
  Grid,
  Typography,
  Modal,
  Button,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from '@mui/material';

import UsersAutocomplete from '../CommonComponents/UsersAutocomplete';
import DatePicker from '../CommonComponents/DatePicker';

import { gridStyle } from './gridStyle';

import CircleIcon from '@mui/icons-material/Circle';

const BulkDataReport = () => {
  const [loggedData, setLoggedData] = useState([]);
  const [loggedPage, setLoggedPage] = useState(0);
  const [loggedPageSize, setLoggedPageSize] = useState(25);
  const [loggedSort, setLoggedSort] = useState([]);
  const [loggedFilter, setLoggedFilter] = useState([]);
  const [loggedTotalRows, setLoggedTotalRows] = useState(0);

  const [data, setData] = useState([]);
  const [forceUpdate, setForceUpdate] = useState(1);

  const [totalRows, setTotalRows] = useState(0);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(25);
  const [filter, setFilter] = useState([]);
  const [sort, setSort] = useState([]);
  const [loading, setLoading] = useState(false);
  const enqNotification = GetAuth().Notification;
  const logout = GetAuth().signOut;
  const [updateData, setUpdateData] = useState(0);

  //FILTERS
  // const [techSelected, setTechSelected] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [rangeFilterBlob, setRangeFilterBlob] = useState([]);
  const [useType, setUseType] = useState(localStorage.getItem('type'));

  const padLeft = (intVal) => {
    return intVal < 10 ? `0${intVal}` : intVal;
  };

  const handleRangeChange = (data, type) => {
    let startTime = startDate;
    let endTime = endDate;
    let oldData = [...rangeFilterBlob];

    switch (type) {
      case 'start_time':
        startTime = data;

        let currentDate = new Date();
        let dateString = `${currentDate.getFullYear()}-${padLeft(
          currentDate.getMonth() + 1
        )}-${padLeft(currentDate.getDate())} 23:59:59`;

        let tempStartData = oldData
          .slice()
          .filter((item) => item.field !== 'start_time');

        data === '%'
          ? setRangeFilterBlob([...tempStartData])
          : setRangeFilterBlob([
              ...tempStartData,
              {
                field: 'start_time',
                start: data + ' 00:00:00',
                stop: dateString,
              },
            ]);
        setStartDate(data);
        break;
      case 'stop_time':
        endTime = data;
        let firstDate = new Date(0);

        let dateString1 = `${firstDate.getFullYear()}-${padLeft(
          firstDate.getMonth() + 1
        )}-${padLeft(firstDate.getDate())} 00:00:00`;

        let tempEndData = oldData
          .slice()
          .filter((item) => item.field !== 'stop_time');

        data === '%'
          ? setRangeFilterBlob([...tempEndData])
          : setRangeFilterBlob([
              ...tempEndData,
              {
                field: 'stop_time',
                start: dateString1,
                stop: data + ' 23:59:59',
              },
            ]);
        setEndDate(data);
        break;
      default:
        // console.log(data);
        break;
    }
  };

  const handelDate = (date, subVal) => {
    const inDate = date;
    // let outDate = inDate.substring(0, inDate.lastIndexOf('T') + 1);
    // outDate = outDate + subVal;
    console.log(`Date: ${date} \nSubval: ${subVal} \nOutDate:`);
    return date;
  };

  const handleClearDateRange = () => {
    if (rangeFilterBlob.length > 0) {
      setRangeFilterBlob([]);
      const newDate = new Date();
      setStartDate(newDate);
      setEndDate(newDate);
    }
  };

  useEffect(() => {
    const newDate = new Date();
    setStartDate(newDate);
    setEndDate(newDate);
  }, []);

  useEffect(() => {
    r2_noHeaderTableUpdate(
      {
        resource: `/api/r2_reports`,
        setDataFunc: setLoggedData,
        setLoadingFunc: setLoading,
        setRows: setLoggedTotalRows,
        startDate: startDate,
        endDate: endDate,
        logout,
      },
      'repair_bulk_data_report'
    );
  }, [startDate, endDate]);

  const Columns = [
    {
      field: 'ticket_type',
      headerName: 'Ticket Type',
      width: 150,
      flex: 0,
      renderCell: (data) => <>{changeFirstToUpper(data.row.ticket_type)}</>,
    },
    {
      field: 'tech_assigned_name',
      headerName: 'Tech',
      width: 150,
      flex: 0,
    },
    {
      field: 'sub_assigned_name',
      headerName: 'Sub Contractor',
      width: 150,
      flex: 0,
    },
    {
      field: 'ticket_nr',
      headerName: 'Ticket Number',
      width: 150,
      flex: 0,
    },
    {
      field: 'date_logged',
      headerName: 'Date Logged',
      width: 150,
      flex: 0,
      renderCell: (data) => (
        <>
          {data.row.date_logged ? convertDate(data.row.date_logged, 0, 10) : ''}
        </>
      ),
    },
    {
      field: 'date_completed',
      headerName: 'Date Completed',
      width: 150,
      flex: 0,
      renderCell: (data) => (
        <>
          {data.row.date_completed
            ? convertDate(data.row.date_completed, 0, 10)
            : ''}
        </>
      ),
    },
    {
      field: 'customer_category_name',
      headerName: 'Category',
      width: 150,
      flex: 0,
    },
    {
      field: 'customer_name',
      headerName: 'Store Name',
      width: 150,
      flex: 0,
    },
    {
      field: 'customer_region_name',
      headerName: 'Region',
      width: 150,
      flex: 0,
    },

    {
      field: 'customer_asset_comp_name',
      headerName: 'Asset Comp',
      width: 150,
      flex: 0,
    },
    {
      field: 'serials_cabinet_types',
      headerName: 'Cabinet Type',
      width: 150,
      flex: 0,
    },
    {
      field: 'serials_numbers',
      headerName: 'Serial Number',
      width: 150,
      flex: 0,
    },
    {
      field: 'serials_descriptions',
      headerName: 'Description Of Work Done',
      width: 150,
      flex: 0,
    },
    {
      field: 'stock_used',
      headerName: 'Stock Used',
      width: 150,
      flex: 0,
    },
    {
      field: 'stock_qty',
      headerName: 'Stock Item Qty',
      width: 150,
      flex: 0,
    },
    {
      field: 'billing_info',
      headerName: 'Invoice Store/Warrantee/Claim/No Charge/Re-Call',
      width: 150,
      flex: 0,
    },
    {
      field: 'invoice_cost_amt',
      headerName: 'Invoice/Cost Amount',
      width: 150,
      flex: 0,
    },
    {
      field: 'gas_type',
      headerName: 'Gas Type',
      width: 150,
      flex: 0,
    },
    {
      field: 'gas_qty',
      headerName: 'Gas Qty',
      width: 150,
      flex: 0,
    },
    {
      field: 'customer_rating',
      headerName: 'Customer Rating',
      width: 150,
      flex: 0,
    },
    {
      field: 'labour_hrs_nt',
      headerName: 'Labour Hrs Nt',
      width: 150,
      flex: 0,
    },
    {
      field: 'labour_hrs_ot1',
      headerName: 'Labour Hrs Ot1',
      width: 150,
      flex: 0,
    },
    {
      field: 'labour_hrs_ot2',
      headerName: 'Labour Hrs Ot2',
      width: 150,
      flex: 0,
    },
    {
      field: 'travel_time_nt',
      headerName: 'Travel Time NT',
      width: 150,
      flex: 0,
    },
    {
      field: 'travel_time_ot1',
      headerName: 'Travel Time OT1',
      width: 150,
      flex: 0,
    },
    {
      field: 'travel_time_ot2',
      headerName: 'Travel Time OT2',
      width: 150,
      flex: 0,
    },
  ];

  return useType !== 'manager' ? (
    <UnauthorisedAccess />
  ) : (
    <Box style={{ height: '73vh', width: '100%' }}>
      <Box>
        <Grid
          container
          // marginBottom='-10px'
        >
          <Grid xs={12} md={6} container columnGap={1}>
            <Grid xs={12} md={3}>
              <DatePicker
                dateLabel='Start Date'
                getDate={(data) =>
                  handleRangeChange(handelDate(data, '00:01:01'), 'start_time')
                }
              ></DatePicker>
            </Grid>
            <Grid xs={12} md={1}></Grid>{' '}
            <Grid xs={12} md={3}>
              <DatePicker
                dateLabel='End Date'
                getDate={(data) =>
                  handleRangeChange(handelDate(data, '23:59:59'), 'stop_time')
                }
              ></DatePicker>
            </Grid>
            <Grid xs={12} md={4} sx={{ display: 'flex', alignItems: 'center' }}>
              <Button
                variant='outlined'
                size='large'
                onClick={handleClearDateRange}
              >
                Clear
              </Button>
            </Grid>
          </Grid>
          <Grid xs={12} md={3} sx={{ display: 'flex', alignItems: 'center' }}>
            <Button
              variant='contained'
              size='large'
              type='info'
              onClick={() => {
                new ExportToCsv('repair_bulk_data_report').ExportRawData(
                  loggedData
                );
              }}
            >
              Extract Data
            </Button>
          </Grid>
        </Grid>
      </Box>
      <Typography
        sx={{ fontWeight: 'bold' }}
        variant='h6'
        align='center'
        xs={{
          background: '#ebedf8',
          margin: '0 auto',
          width: '100%',
          justifyContent: 'center',
          alignItems: 'center',
          flexGrow: 1,
          textAlign: 'center',
          align: 'center',
        }}
      >
        Bulk Data
      </Typography>
      {console.log(loggedData)}
      <DataGrid
        sx={{
          ...gridStyle,
          maxHeight: '85vh',
          width: '100%',
          float: 'left',
          marginRight: '15px !important',
        }}
        rows={loggedData}
        // rows={testData}
        // getRowId={(row) => row?.tech_id}
        // rowCount={loggedTotalRows}
        // loading={loading}
        pagination
        // sortingMode='server'
        // filterMode='server'
        onSortModelChange={(model) => {
          // setLoggedPage(0);
          setLoggedSort(model);
        }}
        // onFilterModelChange={(model) => {
        //   setLoggedPage(0);
        //   setLoggedFilter(model.quickFilterValues);
        // }}
        page={loggedPage}
        // pageSize={loggedPageSize}
        // initialState={{
        //   pagination: {
        //     paginationModel: { pageSize: 5, page: 0 },
        //   },
        // }}
        // paginationMode='client'
        onPageChange={(newPage) => {
          setLoggedPage(newPage);
        }}
        onPageSizeChange={(newPageSize) => {
          setLoggedPage(0);
          setLoggedPageSize(newPageSize);
        }}
        columns={Columns}
        onRowClick={(params) => {}}
        // rowsPerPageOptions={[25, 50, 100]}
        // components={{ Toolbar: CustomCustomerToolbar }}
        autoPageSize
        disableColumnFilter
        disableColumnSelector
        disableDensitySelector
        initialState={{
          aggregation: {
            model: {
              calc2: 'sum',
              year: 'sum',
            },
          },
        }}
        componentsProps={
          {
            // getRowId: loggedData.tech_id,
            // toolbar: {
            //   updateOnclick: () => {
            //     setUpdateData((i) => i + 1);
            //   },
            //   filterOnClick: () => {
            //     // handleFilterOpen();
            //   },
            //   // modalState: modalState,
            // },
          }
        }
      />
    </Box>
  );
};

export default BulkDataReport;

const ticketType = (val) => {
  switch (val) {
    case 'day_start':
      return 'Day Clock';
    case 'repair_ticket':
      return 'Repair Ticket';
    case 'install_ticket':
      return 'Install Ticket';
    default:
      break;
  }
};
